import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Testids } from '@mono/ui-selectors';
import { useState } from 'react';
import { useChatFeedback } from '../../ChatFeedbackContext';
import { deliverableImportFeedback } from './card';
import { workstreamLabel, workstreamStatus } from './shared';
/**
 * NEXT_WORKSTREAM body: a primary button for `payload.nextWorkstreamKey`, a
 * picker revealing every workstream's status, and a stop option. All three
 * actions are `event=navigate` feedback per the proto's
 * DeliverableImportCard doc comment.
 */ export function NextWorkstreamCard({ payload, review }) {
    const [choosing, setChoosing] = useState(false);
    const [chosenLabel, setChosenLabel] = useState(null);
    const [stopped, setStopped] = useState(false);
    const sendFeedback = useChatFeedback();
    const nextWs = payload.nextWorkstreamKey ? review.workstreams.find((w)=>w.key === payload.nextWorkstreamKey) : undefined;
    const pickWorkstream = (ws)=>{
        const label = workstreamLabel(ws);
        setChosenLabel(label);
        setChoosing(false);
        sendFeedback(deliverableImportFeedback({
            event: 'navigate',
            changeSetId: payload.changeSetId,
            workstreamKey: ws.key,
            text: `Program Lead chose to review workstream "${label}" next.`
        }));
    };
    const handleStop = ()=>{
        setStopped(true);
        sendFeedback(deliverableImportFeedback({
            event: 'navigate',
            changeSetId: payload.changeSetId,
            text: 'Program Lead stopped the review for now.'
        }));
    };
    if (stopped) {
        return /*#__PURE__*/ _jsx("div", {
            className: "mt-2 text-xs font-medium text-gray-700",
            children: "Stopped for now — pick up again anytime."
        });
    }
    if (chosenLabel) {
        return /*#__PURE__*/ _jsxs("div", {
            className: "mt-2 text-xs font-medium text-green-700",
            children: [
                'Moving to workstream "',
                chosenLabel,
                '"…'
            ]
        });
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: "mt-2 space-y-2 text-sm text-gray-700",
        children: [
            nextWs ? /*#__PURE__*/ _jsxs("button", {
                type: "button",
                "data-testid": Testids.deliverableImport.reviewWorkstream,
                onClick: ()=>pickWorkstream(nextWs),
                className: "inline-flex items-center px-3 py-1.5 text-xs font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 transition-colors",
                children: [
                    "Review ",
                    workstreamLabel(nextWs)
                ]
            }) : /*#__PURE__*/ _jsx("div", {
                className: "text-xs text-gray-500",
                children: "No workstreams remain to review."
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center gap-3",
                children: [
                    /*#__PURE__*/ _jsx("button", {
                        type: "button",
                        "data-testid": Testids.deliverableImport.chooseWorkstream,
                        onClick: ()=>setChoosing((s)=>!s),
                        className: "text-xs font-medium text-gray-600 hover:text-gray-800",
                        children: "Choose another workstream"
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        type: "button",
                        "data-testid": Testids.deliverableImport.stopForNow,
                        onClick: handleStop,
                        className: "text-xs font-medium text-gray-600 hover:text-gray-800",
                        children: "Stop for now"
                    })
                ]
            }),
            choosing && /*#__PURE__*/ _jsx("ul", {
                className: "border rounded-md divide-y text-xs",
                children: review.workstreams.map((ws)=>/*#__PURE__*/ _jsx("li", {
                        children: /*#__PURE__*/ _jsxs("button", {
                            type: "button",
                            "data-testid": Testids.deliverableImport.reviewWorkstream,
                            onClick: ()=>pickWorkstream(ws),
                            className: "w-full flex items-center justify-between px-2 py-1.5 text-left hover:bg-gray-50",
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "text-gray-900",
                                    children: workstreamLabel(ws)
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "text-gray-500",
                                    children: workstreamStatus(ws)
                                })
                            ]
                        })
                    }, ws.key))
            })
        ]
    });
}
